import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;

  flex: 1;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 600px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: column;
    max-width: 800px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    min-width: 516px;
    padding: 20px 0 20px 60px;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const HowItWorksWrapper = styled.div`
  color: ${({ theme }) => theme.colors.link};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
